// extracted by mini-css-extract-plugin
export var activityContainer = "_nl-0";
export var typingIndicatorContainer = "_nl-1";
export var typingIndicatorDot = "_nl-2";
export var wave = "_nl-3";